import { Pipe, PipeTransform } from '@angular/core';

import { DatasetRow, isDatasetLinkValue } from '@blaze-shared/schema-domain';
import { isNullish } from '@blaze-shared/shared-util';

@Pipe({
  name: 'optionLabel',
  standalone: false,
})
export class OptionLabelPipe implements PipeTransform {
  transform(
    item: DatasetRow | undefined,
    labelField: string,
    defaultValue?: string,
    placeholder?: string,
  ): string | undefined {
    let label = item?.[labelField];
    if (Array.isArray(label)) {
      label = label.map((v) => (isDatasetLinkValue(v) ? v.display : v)).join(', ');
    }
    if (label !== '🗑clear' && isDatasetLinkValue(label)) {
      label = label.display;
    }
    if (isNullish(label) && defaultValue === 'placeholder') {
      return placeholder;
    }
    // Make sure we return a string (instead of a number or boolean, for example)
    return label?.toString();
  }
}
